var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{attrs:{"title":"Credit Note Promo Type"}},[_c('open')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }